export interface RegisterBank {
  r: Uint8Array;
  cr: Uint8Array;
  pc: number;
  csr: number;
  sp: number;
  ea: number;
  dsr: number;
  psw: number;
  elr: [number, number, number, number];
  ecsr: [number, number, number, number];
  epsw: [number, number, number, number];
  cycleCount: number;
}

export function createRegisterBank(): RegisterBank {
  return {
    r: new Uint8Array(16),
    cr: new Uint8Array(16),
    pc: 0,
    csr: 0,
    sp: 0,
    ea: 0,
    dsr: 0,
    psw: 0,
    elr: [0, 0, 0, 0],
    ecsr: [0, 0, 0, 0],
    epsw: [0, 0, 0, 0],
    cycleCount: 0,
  };
}

export function readER(r: Uint8Array, n: number): number {
  return (r[n] << 8) | r[n + 1];
}

export function writeER(r: Uint8Array, n: number, val: number): void {
  r[n] = (val >> 8) & 0xFF;
  r[n + 1] = val & 0xFF;
}

export function readXR(r: Uint8Array, n: number): number {
  return ((r[n] << 24) | (r[n + 1] << 16) | (r[n + 2] << 8) | r[n + 3]) >>> 0;
}

export function writeXR(r: Uint8Array, n: number, val: number): void {
  r[n] = (val >> 24) & 0xFF;
  r[n + 1] = (val >> 16) & 0xFF;
  r[n + 2] = (val >> 8) & 0xFF;
  r[n + 3] = val & 0xFF;
}

export function readQR(r: Uint8Array, n: number): number {
  let val = 0;
  for (let i = 0; i < 8; i++) {
    val = (val << 8) | r[n + i];
  }
  return val;
}

export function writeQR(r: Uint8Array, n: number, val: number): void {
  for (let i = 7; i >= 0; i--) {
    r[n + i] = val & 0xFF;
    val >>>= 8;
  }
}
